<ng-container *transloco="let t;">
    <div class="list-group">
        <div class="list-group-item d-flex align-items-center">
            <div class="list-group">
                <ng-template #popContent let-componentAndData="componentAndData"
                             let-item="item"
                             let-operator="operator"
                             let-filterValue="filterValue"
                             let-popover="popover">
                    <div class="d-flex w-100">
                        <ng-container
                                *ngComponentOutlet="componentAndData.component; inputs :{ options: componentAndData.inputs, item: item, operator:operator, filterValue: filterValue, popover:popover };"></ng-container>
                    </div>
                </ng-template>
                @for (filter of filtersList; track filter; let index = $index) {
                    <div class="d-inline-flex applied-filter-wrapper"
                         [ngClass]="{'invalid': filter.isApplied === false}">
                        <div class="list-group-item d-flex align-items-center filter_{{filter.uuid}}_{{index}}"
                             triggers="manual"
                             #p1="ngbPopover"
                             placement="bottom-left"
                             [ngbPopover]="popContent"
                             [container]="'.list-group-item.filter_{{filter.uuid}}_{{index}} .list-item-main'"
                             [autoClose]="'outside'"
                             [popoverContext]="{
                            componentAndData: filterChooser.choose(filter),
                            item: filter,
                            filterValue: filter.value,
                            operator: filter.operator,
                            popover:p1
                          }"
                             [popoverClass]="'advanced-filter'"
                             [openDelay]="'300'"
                             [disablePopover]="isDisable(p1, filter)"
                             (click)="p1.open()"
                             (hidden)="onPopoverClose(p1, filter)"
                        >
                    <span class="list-item-main">
                        @if (filter?.icon) {
                            <span class="icon me-75 d-flex align-items-center">
                              <i [size]="14" [data-feather]="filter.icon"></i>
                            </span>
                        }
                        <span>
                         <span class="filter-text">{{ filter?.text }}</span>
                              <span class="filter-text"><app-applied-filter-filter-value-preview
                                      [filter]="filter"></app-applied-filter-filter-value-preview> </span>
                        </span>
                         <span class="ms-75 m-0 removeFilter cursor-pointer" container="body" placement="auto"
                               [autoClose]="true"
                               triggers="hover"
                               [ngbTooltip]="t('Remove filter tooltip (Advanced filters) - Remove this filter')"
                               (click)="onRemoveFilterClick(filter)">
                          <i class="" [size]="14" data-feather="x"></i>
                         </span>
                    </span>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</ng-container>
